module.exports = __webpack_public_path__ + "4e152f85ff7a97c29c49ba414c37e72e.svg";